import { NotificationBars } from 'presentation/ui/components/notification-bars/NotificationBars';
import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { MaintenanceLogEntryViewModel } from 'services/maintenance-log/domain/model/MaintenanceLogEntryModel';

import { useKeyPress } from 'presentation/hooks';
import { NotificationBar } from 'presentation/ui/components/notification-bar/NotificationBar';
import { NotificationLevel } from 'presentation/ui/components/notification-bar/NotificationLevel';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { FormLayoutSection } from 'presentation/ui/layouts/form-layout/form-layout-section/FormLayoutSection';
import { FormLayout } from 'presentation/ui/layouts/form-layout/FormLayout';
import { FormLayoutSectionAlign } from 'presentation/ui/layouts/form-layout/FormLayoutSectionAlign';
import { ButtonPrimary } from 'presentation/ui/partials/button/button-primary/ButtonPrimary';
import { Label } from 'presentation/ui/partials/input/label/Label';
import { Textarea } from 'presentation/ui/partials/input/textarea/Textarea';

export interface MaintenanceLogCommentFormStep1Props {
	maintenanceLogEntry: MaintenanceLogEntryViewModel;
	onClickNext: () => void;
	onChange?: (identifier: string, value: string | Date) => void;
	invalidInputs?: string[];
}

export const MaintenanceLogCommentFormStep1 = (props: MaintenanceLogCommentFormStep1Props): JSX.Element => {
	const { maintenanceLogEntry, onClickNext, invalidInputs = [], onChange } = props;

	const l10nContext = useContext(L10nContext);

	useKeyPress('Enter', onClickNext);

	const notification = !invalidInputs.length ?
		null :
		<NotificationBar
			level={NotificationLevel.LEVEL_ERROR}
			message={`${invalidInputs.join(` ${l10nContext.translate('common.text.and', 'und')} `)} ${l10nContext.translate('common.modal.notificationError', ' darf nicht leer sein')}`}
		/>;

	return (
		<FormLayout
			align={FormLayoutSectionAlign.ALIGN_HORIZONTAL}
			onSubmit={onClickNext}
		>
			<NotificationBars>
				{notification}
			</NotificationBars>

			<FormLayoutSection>
				<Label label={`${l10nContext.translate('view.maintenances.modal.action.edit.resolve', 'Maßnahme')}`}>
					<Textarea
						defaultValue={maintenanceLogEntry.IncidentSolution ?? ''}
						onChange={(event) => onChange('IncidentSolution', event.target.value)}
					/>
				</Label>
			</FormLayoutSection>

			<FormLayoutSection align={FormLayoutSectionAlign.ALIGN_BOTTOM}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonPrimary
							buttonText={l10nContext.translate('common.button.next', 'Weiter')}
							type='submit'
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</FormLayoutSection>
		</FormLayout>
	);
};
